if (typeof(pa) !== 'undefined') {
  pa.setConfigurations({
    site: process.env.TIM_PIANO_ANALYTICS_SITE_ID,
    collectDomain: process.env.PIANO_ANALYTICS_COLLECT_DOMAIN
  });
}



// WEBPACK FOOTER //
// ./src/at_internet/config.js